import { Link } from "react-router-dom";
import "../App.css";

function DrillDown() {
  return (
    <div id="container">
      <div class="">
        <div class="">
          <div class="tailwind css-myl2ny css-exq74d css-gs60ek">
            <div class="min-h-screen transition-colors duration-200 bg-gray-50 text-gray-900">
              <div class="border-b sticky top-0 z-40 backdrop-blur-sm bg-white/95 border-gray-200">
                <div class="max-w-7xl mx-auto px-6 py-4">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-4">
                      <button
                        data-slot="button"
                        class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 flex items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-arrow-left w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="m12 19-7-7 7-7"></path>
                          <path d="M19 12H5"></path>
                        </svg>
                        <Link to="/summary">Back to Analysis</Link>
                      </button>
                      <div
                        data-orientation="vertical"
                        role="none"
                        data-slot="separator-root"
                        class="bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px h-8"
                      ></div>
                      <div class="flex items-center gap-3">
                        <img
                          src="/sai-logo.avif"
                          alt="SAI Agent"
                          class="w-8 h-8"
                        />
                        <div>
                          <h1 class="font-semibold text-lg text-gray-900">
                            Redline Detail
                          </h1>
                          <p class="text-xs text-gray-500">
                            IP Assignment (Founders)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="flex items-center gap-3">
                      <button
                        data-slot="button"
                        class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 flex items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-download w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M12 15V3"></path>
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <path d="m7 10 5 5 5-5"></path>
                        </svg>
                        Export Details
                      </button>
                      <button
                        data-slot="button"
                        class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-moon w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"></path>
                        </svg>
                      </button>
                      <div class="flex items-center gap-2">
                        <div class="avatar-circle" data-initials="GC"></div>
                        <span class="text-sm font-medium text-gray-900">
                          Gordon Caplan
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="max-w-7xl mx-auto px-6 py-8">
                <div class="mb-8">
                  <div class="flex items-center gap-3 mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-scale w-8 h-8 text-sai-blue"
                      aria-hidden="true"
                    >
                      <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                      <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                      <path d="M7 21h10"></path>
                      <path d="M12 3v18"></path>
                      <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
                    </svg>
                    <div>
                      <h1 class="text-3xl font-semibold text-gray-900">
                        Redline Drill-Down: IP Assignment (Founders)
                      </h1>
                      <p class="text-lg text-gray-600">(IP Assignment)</p>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 md:grid-cols-6 gap-4 mb-6">
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        Severity:
                      </label>
                      <span
                        data-slot="badge"
                        class="inline-flex items-center justify-center rounded-md px-2 py-0.5 text-xs w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 border font-medium mt-1"
                      >
                        HIGH
                      </span>
                    </div>
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        Current State:
                      </label>
                      <div class="text-sm font-medium mt-1 text-gray-900">
                        4 – Lawyer Owned
                      </div>
                    </div>
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        Assignee:
                      </label>
                      <div class="text-sm font-medium mt-1 text-gray-900">
                        External Counsel (Wilson Sonsini)
                      </div>
                    </div>
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        Status:
                      </label>
                      <div class="text-sm font-medium mt-1 text-gray-900">
                        In progress
                      </div>
                    </div>
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        ETA:
                      </label>
                      <div class="text-sm font-medium mt-1 text-gray-900">
                        Aug 15 2025
                      </div>
                    </div>
                    <div>
                      <label class="text-sm font-medium text-gray-600">
                        Last Updated:
                      </label>
                      <div class="text-sm font-medium mt-1 text-gray-900">
                        Aug 3 2025
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    1. Summary
                  </h2>
                  <p class="text-base leading-relaxed text-gray-600">
                    Founding CTO never executed an intellectual-property
                    assignment covering code written before incorporation (Jan
                    2024 – Mar 2024). All core patents and trade secrets
                    originate in that codebase.
                  </p>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    2. Source Documents
                  </h2>
                  <ul class="space-y-3">
                    <li class="flex items-start gap-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-folder-open w-4 h-4 text-gray-400 mt-1 flex-shrink-0"
                        aria-hidden="true"
                      >
                        <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                      </svg>
                      <div>
                        <span class="font-medium text-gray-900">
                          2024-01-15 –
                        </span>
                        <span class="ml-2 text-gray-600">
                          Pre-incorp_prototype.zip (internal Git snapshot)
                        </span>
                      </div>
                    </li>
                    <li class="flex items-start gap-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-folder-open w-4 h-4 text-gray-400 mt-1 flex-shrink-0"
                        aria-hidden="true"
                      >
                        <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                      </svg>
                      <div>
                        <span class="font-medium text-gray-900">
                          2024-03-22 –
                        </span>
                        <span class="ml-2 text-gray-600">
                          Draft IP Assignment (unsigned)
                        </span>
                        <span class="ml-2 text-sm text-gray-500">
                          – Doc-ID IP-DRAFT-v3.pdf
                        </span>
                      </div>
                    </li>
                    <li class="flex items-start gap-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-folder-open w-4 h-4 text-gray-400 mt-1 flex-shrink-0"
                        aria-hidden="true"
                      >
                        <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                      </svg>
                      <div>
                        <span class="font-medium text-gray-900">
                          2024-05-19 –
                        </span>
                        <span class="ml-2 text-gray-600">
                          Email thread 'Re: Assignment paperwork'
                        </span>
                      </div>
                    </li>
                    <li class="flex items-start gap-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-folder-open w-4 h-4 text-gray-400 mt-1 flex-shrink-0"
                        aria-hidden="true"
                      >
                        <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                      </svg>
                      <div>
                        <span class="font-medium text-gray-900">
                          2024-06-02 –
                        </span>
                        <span class="ml-2 text-gray-600">
                          Series A closing checklist (missing attachment #12)
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    3. Historical Precedents (Comparable VC Deals)
                  </h2>
                  <ul class="space-y-4">
                    <li class="border-l-2 border-sai-blue pl-4">
                      <div class="font-medium mb-1 text-gray-900">
                        2019 – FinTechCo:
                      </div>
                      <div class="text-sm text-gray-600 mb-1">
                        CTO IP gap on encryption engine
                      </div>
                      <div class="text-sm text-gray-600">
                        → signed nunc pro tunc assignment + rep-and-warranty
                        insurance (US $3M premium).
                      </div>
                    </li>
                    <li class="border-l-2 border-sai-blue pl-4">
                      <div class="font-medium mb-1 text-gray-900">
                        2021 – HealthAI:
                      </div>
                      <div class="text-sm text-gray-600 mb-1">
                        Founder held separate patent
                      </div>
                      <div class="text-sm text-gray-600">
                        → patent assigned at closing; 2% escrow for 24 months.
                      </div>
                    </li>
                    <li class="border-l-2 border-sai-blue pl-4">
                      <div class="font-medium mb-1 text-gray-900">
                        2023 – CloudOps:
                      </div>
                      <div class="text-sm text-gray-600 mb-1">
                        Copyleft OSS + founder IP
                      </div>
                      <div class="text-sm text-gray-600">
                        → carved-out OSS module, rewrote critical path; deal
                        delayed 6 weeks.
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    4. Comments &amp; Legal Analysis
                  </h2>
                  <div class="space-y-4">
                    <div class="p-4 rounded-lg bg-gray-50">
                      <div class="flex items-center gap-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-user w-4 h-4 text-gray-400"
                          aria-hidden="true"
                        >
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span class="font-medium text-gray-900">
                          2025-08-01 (Partner):
                        </span>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs"
                        >
                          Partner
                        </span>
                      </div>
                      <p class="text-sm leading-relaxed ml-7 text-gray-600">
                        Recommend nunc pro tunc assignment with indemnity cap =
                        1x purchase price.
                      </p>
                    </div>
                    <div class="p-4 rounded-lg bg-gray-50">
                      <div class="flex items-center gap-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-user w-4 h-4 text-gray-400"
                          aria-hidden="true"
                        >
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span class="font-medium text-gray-900">
                          2025-08-02 (Associate):
                        </span>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs"
                        >
                          Associate
                        </span>
                      </div>
                      <p class="text-sm leading-relaxed ml-7 text-gray-600">
                        Israeli law permits back-dating if consideration stated;
                        require tax ruling.
                      </p>
                    </div>
                    <div class="p-4 rounded-lg bg-gray-50">
                      <div class="flex items-center gap-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-user w-4 h-4 text-gray-400"
                          aria-hidden="true"
                        >
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span class="font-medium text-gray-900">
                          2025-08-03 (CTO):
                        </span>
                        <span
                          data-slot="badge"
                          class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden text-foreground [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs"
                        >
                          CTO
                        </span>
                      </div>
                      <p class="text-sm leading-relaxed ml-7 text-gray-600">
                        Ready to sign; requests liability carve-out for
                        post-incorporation code.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 mb-8 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    5. Recommended Resolution Steps
                  </h2>
                  <ol class="space-y-2">
                    <li class="flex items-start gap-3">
                      <span class="flex-shrink-0 w-6 h-6 rounded-full bg-sai-blue text-white text-sm font-medium flex items-center justify-center mt-0.5">
                        1
                      </span>
                      <span class="text-sm leading-relaxed text-gray-600">
                        Draft final IP Assignment (nunc pro tunc to 1 Jan 2024).
                      </span>
                    </li>
                    <li class="flex items-start gap-3">
                      <span class="flex-shrink-0 w-6 h-6 rounded-full bg-sai-blue text-white text-sm font-medium flex items-center justify-center mt-0.5">
                        2
                      </span>
                      <span class="text-sm leading-relaxed text-gray-600">
                        Obtain board consent to execute.
                      </span>
                    </li>
                    <li class="flex items-start gap-3">
                      <span class="flex-shrink-0 w-6 h-6 rounded-full bg-sai-blue text-white text-sm font-medium flex items-center justify-center mt-0.5">
                        3
                      </span>
                      <span class="text-sm leading-relaxed text-gray-600">
                        Record assignment with USPTO within 10 days.
                      </span>
                    </li>
                    <li class="flex items-start gap-3">
                      <span class="flex-shrink-0 w-6 h-6 rounded-full bg-sai-blue text-white text-sm font-medium flex items-center justify-center mt-0.5">
                        4
                      </span>
                      <span class="text-sm leading-relaxed text-gray-600">
                        Insert rep-and-warranty clause section 7.2(e) with
                        18-month survival.
                      </span>
                    </li>
                  </ol>
                </div>
                <div
                  data-slot="card"
                  class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 border-l-4 bg-white border-gray-200"
                >
                  <h2 class="text-xl font-medium mb-4 text-gray-900">
                    6. Risk Impact if Unresolved
                  </h2>
                  <div class="space-y-4">
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-dollar-sign w-4 h-4 text-red-500"
                          aria-hidden="true"
                        >
                          <line x1="12" x2="12" y1="2" y2="22"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                        <span class="font-medium text-gray-900">
                          Financing:
                        </span>
                      </div>
                      <p class="text-sm ml-6 text-gray-600">
                        Closing delay; potential 10% escrow hold-back (approx.
                        US $2M).
                      </p>
                    </div>
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-scale w-4 h-4 text-red-500"
                          aria-hidden="true"
                        >
                          <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                          <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                          <path d="M7 21h10"></path>
                          <path d="M12 3v18"></path>
                          <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
                        </svg>
                        <span class="font-medium text-gray-900">
                          Litigation:
                        </span>
                      </div>
                      <p class="text-sm ml-6 text-gray-600">
                        Possible competing claim by ex-contractor.
                      </p>
                    </div>
                    <div>
                      <div class="flex items-center gap-2 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-trending-up w-4 h-4 text-red-500"
                          aria-hidden="true"
                        >
                          <path d="M16 7h6v6"></path>
                          <path d="m22 7-8.5 8.5-5-5L2 17"></path>
                        </svg>
                        <span class="font-medium text-gray-900">Exit:</span>
                      </div>
                      <p class="text-sm ml-6 text-gray-600">
                        Acquirers likely to flag issue, lowering valuation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DrillDown;
